import { isProd } from 'src/config/index';
export const US_HIGH_RISK_MCC = [
  // '4215',
  // '4411',
  // '4511',
  // '4722',
  // '4816',
  // '4829',
  // '4899',
  // '5045',
  // '5122',
  // '5262',
  // '5499',
  // '5521',
  // '5712',
  // '5734',
  // '5813',
  // '5815',
  // '5816',
  // '5817',
  // '5818',
  // '5912',
  // '5960',
  // '5962',
  // '5963',
  // '5964',
  // '5965',
  // '5966',
  // '5967',
  // '5968',
  // '5969',
  // '5972',
  // '5977',
  // '6010',
  // '6011',
  // '6012',
  // '6051',
  // '6211',
  // '6300',
  // '6540',
  // '6513',
  // '6540',
  // '7011',
  // '7012',
  // '7273',
  // '7297',
  // '7311',
  // '7321',
  // '7372',
  // '7379',
  // '7392',
  // '7399',
  // '7922',
  // '7991',
  // '7995',
  // '7996',
  // '8241',
  // '8999',
  // '9223'
].filter((code) => {
  if (isProd) {
    return true;
  } else {
    return code != '4215';
  }
});
